import React, { useState } from "react";
import Box from "ReusableComponents/Box";

import RightPathWhite from "assets/rightpathWhite.png";
import RightPath from "assets/rightPath.svg";
import { useTranslation } from "react-i18next";

import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";
import Button from "ReusableComponents/Button";
import { useLanguage } from "LanguageContext";

const ContactBanner = ({ small }) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();

  const [hover, setHover] = useState(false);

  return (
    <Box
      h="289px"
      background="white"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        dispaly="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign={small && "center"}
        w={small && "80%"}
      >
        <Text
          fontWeight="bold"
          fontSize={small ? SIZES.twenty : "30px"}
          w={small && "80%"}
          margin={small && "0 auto"}
        >
          {t("Want to move your fleet to electric, we can help you.")}
        </Text>
        <Button
          isHover={true}
          background={hover ? COLORS.black : COLORS.primary}
          display="flex"
          w="218px"
          alignItems="center"
          justifyContent="center"
          hoverBackground={true}
          cursor="pointer"
          margin="36px auto"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() =>
            (window.location.href = `/${selectedLanguage}/contact-us`)
          }
        >
          <Text
            fontSize="16px"
            fontWeight="bold"
            textColor={hover ? COLORS.white : COLORS.black}
          >
            {t("Contact Us")}
          </Text>
          <img
            src={hover ? RightPathWhite : RightPath}
            alt="arrow"
            style={{ margin: "0 8px", height: 16 }}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default ContactBanner;
